var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BackButton'),_c('ContentTemplate',{attrs:{"contentUrlPath":"adults_chill_out1"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }